import type { Reducer } from 'redux';
import type { AppState } from './state';

// Actions
export * from './actions';

// State
export {
    getPackageState,
    appStatePackageStateKey,
    getAppState,
    LivePersonaCardInitializationState,
    LivePersonaEditorInitializationState,
} from './state';
export type { AppState } from './state';
export type { AppDataState, HubPersonasMap } from './state';

export type {
    ClickedHubPersonaState,
    CheckedHubPersonaDetails,
    NavigationState,
    SearchQuery,
    Route,
} from './state/view/navigationState';
export type { SearchState } from './state/data/searchState';
export { FolderLoadingState } from './state/data/contactFoldersState';
export type {
    ContactFoldersState,
    FolderIdToHubPersonaIdsMap,
    FolderLoadingStateMap,
    FolderErrorStateMap,
} from './state/data/contactFoldersState';
export * from './state/view/layoutState';
export * from './state/data/hubDataState';
export * from './state/data/groupsHubDataState';
export * from './state/data/groupsHubPrefetchState';
export * from './state/view/createEditorsState';
export * from './state/view/mailComposeState';
export * from './state/view/groupsPendingActionsState';
export { DisplayDialog } from './state/view/asyncDialogState';
export type { SearchResultState } from './state/data/searchState';
export type { EditContactOptionsState } from './state/view/editContactOptionsState';

// Selectors
export * from './selectors';

// Reducer
export function getAppStateReducer(): Promise<Reducer<AppState>> {
    // We dynamically import the reducer to avoid circular dependencies when other packages import from this package
    return import(
        /* webpackChunkName: "AppStateReducer", webpackMode: "eager" */ './reducers/reducer'
    ).then(reducerImport => {
        return reducerImport.default;
    });
}

export {
    getPendingRequestGroupsCount,
    getExpiringGroupsCount,
} from './selectors/groupsNeedingUserActionCount';
